import  { useState } from 'react';  
import { Card,  Col,  Collapse } from 'reactstrap';
import SkillCheckBox from './SkillCheckBox';
import HeaderWithIcon from '../../Common/HeaderWithIcon';
import { Btn } from '../../../../AbstractElements';
import { AllSkills, SpecificSkills } from '../../../../Constant';

const SkillClass = () => {
  const [isOpen, setIsOpen] = useState(true);
  return (
      <Col xl="12">
        <Card>
          <HeaderWithIcon heading={SpecificSkills} isOpen={isOpen} setIsOpen={setIsOpen}/>
          <Collapse isOpen={isOpen}>
            <SkillCheckBox/>            
            <Btn className='btn-block text-center w-100' color='primary'>{AllSkills}</Btn>
          </Collapse>
        </Card>
      </Col>
  );
};

export default SkillClass;
